export const Elevation = {
    DIMMING: 1000,
    CARD_ON_DIMMING: 1100,
    DATEPICKER: 1150,
    SELECT_LIST: 1150,
    SUGGESTIONS_LIST: 1150,
    BANNER: 1200,
    TOOLTIP: 1300
};
